import { useMutation } from "react-query";
import { addCameraSystem } from "../../../../../actions/Utilities/CameraSystem";
import { toast } from "components/toastNotification";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateCameraSystem, cameraSystemReFetching } from "../atoms/atoms";
import { ICameraSystem } from "../types";

const useAddCameraSystem = () => {
  const setActionAddState = useSetRecoilState(addStateCameraSystem);
  const [isReFetching, setIsReFetching] = useRecoilState(
    cameraSystemReFetching
  );
  const { mutate } = useMutation(
    (NewData: ICameraSystem) => addCameraSystem(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Camera System failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Camera System Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Camera System Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Camera System failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Camera System failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            case res.includes("Action object"):
              toast.fire(
                "Adding Camera System failed ",
                `Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Camera System failed", res, "error");
          }
        }
        // Redirect to View
        setActionAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Camera System failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddCameraSystem;
